import { useState, useCallback } from 'react';
const SAFE_AREA_KEY = 'player.safeAreas';
const VALID_SAFE_AREAS = ['4:3', '16:9'];
function loadSavedSafeAreas() {
    try {
        const raw = localStorage.getItem(SAFE_AREA_KEY);
        if (!raw)
            return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed))
            return [];
        return parsed.filter((v) => VALID_SAFE_AREAS.includes(v));
    }
    catch {
        // localStorage unavailable or invalid JSON
    }
    return [];
}
export function useVideoOverlays() {
    const [activeMatte, setActiveMatte] = useState(null);
    const [activeSafeAreas, setActiveSafeAreasState] = useState(loadSavedSafeAreas);
    const toggleSafeArea = useCallback((kind) => {
        setActiveSafeAreasState((prev) => {
            const next = prev.includes(kind)
                ? prev.filter((k) => k !== kind)
                : [...prev, kind];
            try {
                if (next.length === 0) {
                    localStorage.removeItem(SAFE_AREA_KEY);
                }
                else {
                    localStorage.setItem(SAFE_AREA_KEY, JSON.stringify(next));
                }
            }
            catch {
                // localStorage unavailable
            }
            return next;
        });
    }, []);
    return { activeMatte, setActiveMatte, activeSafeAreas, toggleSafeArea };
}
